
export const invnumberConstants = {
  GET_INV_NUMBERS_REQUEST: 'GET_INV_NUMBERS_REQUEST',
  GET_INV_NUMBERS_SUCCESS: 'GET_INV_NUMBERS_SUCCESS',
  GET_INV_NUMBERS_FAILURE: 'GET_INV_NUMBERS_FAILURE',

  GET_INV_NUMBER_REQUEST: 'GET_INV_NUMBER_REQUEST',
  GET_INV_NUMBER_SUCCESS: 'GET_INV_NUMBER_SUCCESS',
  GET_INV_NUMBER_FAILURE: 'GET_INV_NUMBER_FAILURE',

  GET_INV_NUMBER_JURISDICTIONS_REQUEST: 'GET_INV_NUMBER_JURISDICTIONS_REQUEST',
  GET_INV_NUMBER_JURISDICTIONS_SUCCESS: 'GET_INV_NUMBER_JURISDICTIONS_SUCCESS',
  GET_INV_NUMBER_JURISDICTIONS_FAILURE: 'GET_INV_NUMBER_JURISDICTIONS_FAILURE',

  GET_INV_NUMBER_CITIES_REQUEST: 'GET_INV_NUMBER_CITIES_REQUEST',
  GET_INV_NUMBER_CITIES_SUCCESS: 'GET_INV_NUMBER_CITIES_SUCCESS',
  GET_INV_NUMBER_CITIES_FAILURE: 'GET_INV_NUMBER_CITIES_FAILURE',

  ADD_INV_NUMBER_REQUEST: 'ADD_INV_NUMBER_REQUEST',
  ADD_INV_NUMBER_SUCCESS: 'ADD_INV_NUMBER_SUCCESS',
  ADD_INV_NUMBER_FAILURE: 'ADD_INV_NUMBER_FAILURE',

  ADD_BULK_INV_NUMBER_REQUEST: 'ADD_BULK_INV_NUMBER_REQUEST',
  ADD_BULK_INV_NUMBER_SUCCESS: 'ADD_BULK_INV_NUMBER_SUCCESS',
  ADD_BULK_INV_NUMBER_FAILURE: 'ADD_BULK_INV_NUMBER_FAILURE',

};
